import create from 'zustand'

import { generalStoreCreator } from './general.store'

export const useStore = create((set) => ({
  ...generalStoreCreator(set),
}))
